var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 482.039 482.039",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.773,211.922c0.59,1.53,0.18,3.28-1.04,4.4l-33.73,30.79l33.73,30.8c1.22,1.11,1.63,2.86,1.04,4.4 c-0.6,1.54-2.08,2.55-3.73,2.55h-89.03v32c0,2.21-1.79,4-4,4h-47.71c2.36,8.43,3.58,17.11,3.58,25.86c0,15.57-3.9,31.1-11.26,44.91 c-0.5,0.94-1.35,1.64-2.37,1.95c-0.38,0.11-0.77,0.17-1.16,0.17c-0.65,0-1.3-0.16-1.88-0.47c-26.16-13.95-44.1-38.88-49.18-67.75 l-34.01,34.01l-34.01-34.01c-5.08,28.87-23.02,53.8-49.18,67.75c-0.59,0.31-1.23,0.47-1.88,0.47c-0.4,0-0.79-0.06-1.17-0.17 c-1.01-0.31-1.86-1.01-2.36-1.95c-7.37-13.81-11.26-29.34-11.26-44.91c0-8.75,1.21-17.43,3.58-25.86h-47.72c-2.21,0-4-1.79-4-4v-32 H4.003c-1.65,0-3.14-1.01-3.73-2.55c-0.6-1.54-0.19-3.29,1.03-4.4l33.73-30.8l-33.73-30.79c-1.22-1.12-1.63-2.87-1.03-4.4 c0.59-1.54,2.08-2.56,3.73-2.56h70.49c-15.39-10.36-27.88-24.68-35.9-41.46c-3.88-8.11-6.7-16.75-8.39-25.69 c-0.41-2.17,1.01-4.27,3.18-4.68c9.15-1.73,18.42-2.22,27.65-1.49c-5.19-14.01-7.49-28.76-6.83-43.93 c0.05-1.06,0.51-2.06,1.29-2.78c0.79-0.71,1.82-1.09,2.88-1.04c31.56,1.39,61.03,15.94,81.31,40.05 c13.69-10.18,30.22-15.68,47.6-15.68c20.06,0,38.99,7.34,53.74,20.74c14.74-13.4,33.67-20.74,53.74-20.74 c17.37,0,33.9,5.5,47.6,15.68c20.28-24.11,49.74-38.66,81.3-40.05c1.07-0.05,2.1,0.33,2.88,1.04c0.78,0.72,1.25,1.72,1.29,2.78 c0.66,15.17-1.63,29.92-6.82,43.93c9.22-0.73,18.49-0.24,27.64,1.49c2.17,0.41,3.6,2.51,3.19,4.68c-1.7,8.94-4.52,17.58-8.39,25.69 c-8.03,16.78-20.52,31.1-35.9,41.46h70.49C479.693,209.362,481.173,210.382,481.773,211.922z M438.373,244.162l29.35-26.8h-96.85 c-0.99,3.04-2.14,6.01-3.48,8.91l20.43,20.25c0.73,0.72,1.19,1.73,1.19,2.84v27.5h78.71l-29.35-26.79c-0.83-0.76-1.3-1.83-1.3-2.96 C437.073,245.992,437.543,244.922,438.373,244.162z M436.233,164.452c2.99-6.27,5.31-12.89,6.9-19.74 c-9.21-1.34-18.53-1.35-27.76-0.01c-16.67,2.43-32.45,9.25-45.74,19.72c3.35,8.91,5.13,18.44,5.13,28.24 c0,5.68-0.61,11.27-1.76,16.7h18.61C411.093,199.822,426.923,183.922,436.233,164.452z M411.983,137.152 c5.37-12.92,8.05-26.55,7.96-40.61c-27.74,2.3-53.45,15.57-71.41,36.89c0.95,0.86,1.88,1.75,2.79,2.66 c6.18,6.17,11.19,13.18,14.99,20.76C379.753,146.692,395.433,139.932,411.983,137.152z M381.013,312.862v-59.5h-279.99v59.5 H381.013z M354.923,245.362h20.37l-11.8-11.7C361.023,237.782,358.153,241.692,354.923,245.362z M366.763,192.662 c0-5.59-0.66-11.08-1.89-16.4l-27.54,19.5c-27.52,19.5-62.57,23.47-93.76,10.63c-31.53-12.99-68.38-6.73-93.86,15.93l-18.06,16.06 c1.48,1.79,3.05,3.53,4.72,5.19l1.78,1.79h205.73l1.79-1.79C359.273,229.972,366.763,211.892,366.763,192.662z M332.713,189.242 l29.78-21.1c-3.55-9.81-9.23-18.8-16.82-26.39c-13.6-13.6-31.68-21.09-50.91-21.09c-19.24,0-37.32,7.49-50.91,21.09l-2.83,2.83 l-2.83-2.83c-13.6-13.6-31.68-21.09-50.91-21.09c-19.24,0-37.32,7.49-50.91,21.09c-13.6,13.6-21.09,31.68-21.09,50.91 c0,14.15,4.06,27.66,11.62,39.24l17.49-15.56c13.72-12.19,30.53-20.26,48.63-23.34c18.09-3.06,36.63-1,53.6,5.99 C275.253,210.782,307.443,207.142,332.713,189.242z M332.883,346.722c0-8.77-1.33-17.45-3.91-25.86h-46.58 c3.65,26.49,19.03,49.7,42.01,63.35C329.963,372.502,332.883,359.622,332.883,346.722z M241.023,348.222l27.36-27.36h-54.73 L241.023,348.222z M199.643,320.862h-46.57c-2.59,8.41-3.91,17.09-3.91,25.86c0,12.9,2.92,25.78,8.47,37.49 C180.623,370.562,196.003,347.352,199.643,320.862z M130.713,136.092c0.91-0.91,1.84-1.8,2.79-2.66 c-17.96-21.32-43.66-34.59-71.41-36.89c-0.08,14.06,2.59,27.69,7.97,40.61c16.54,2.78,32.22,9.54,45.66,19.7 C119.523,149.272,124.543,142.262,130.713,136.092z M106.753,245.362h20.36c-3.22-3.67-6.09-7.58-8.56-11.7L106.753,245.362z  M94.223,246.512l20.43-20.24c-1.35-2.9-2.5-5.87-3.48-8.91h-96.86l29.35,26.8c0.83,0.76,1.31,1.83,1.31,2.95 c0,1.13-0.48,2.2-1.31,2.96l-29.35,26.79h78.71v-27.5C93.023,248.242,93.483,247.242,94.223,246.512z M90.423,209.362h18.61 c-1.15-5.43-1.75-11.02-1.75-16.7c0-9.8,1.77-19.33,5.13-28.24c-13.3-10.47-29.08-17.29-45.75-19.72 c-9.22-1.34-18.54-1.34-27.76,0.01c1.59,6.85,3.91,13.47,6.91,19.74C55.123,183.922,70.943,199.822,90.423,209.362z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.7228,
    y1: 247.1117,
    x2: 367.3928,
    y2: 247.1117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    style: {
      stopColor: "#E9D5B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    style: {
      stopColor: "#DCC5AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4338,
    style: {
      stopColor: "#C8AB95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5598,
    style: {
      stopColor: "#B59280"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#A28373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#715B50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    style: {
      stopColor: "#231C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9847,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M467.723,217.362l-29.35,26.8c-0.83,0.76-1.3,1.83-1.3,2.95c0,1.13,0.47,2.2,1.3,2.96 l29.35,26.79h-78.71v-27.5c0-1.11-0.46-2.12-1.19-2.84l-20.43-20.25c1.34-2.9,2.49-5.87,3.48-8.91H467.723z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.3828,
    y1: 143.7017,
    x2: 406.3828,
    y2: 209.3617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DD401"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    style: {
      stopColor: "#9BD101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    style: {
      stopColor: "#94C701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#88B701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5753,
    style: {
      stopColor: "#77A001"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    style: {
      stopColor: "#618301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7933,
    style: {
      stopColor: "#465F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#263400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#020300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M443.133,144.712c-1.59,6.85-3.91,13.47-6.9,19.74c-9.31,19.47-25.14,35.37-44.62,44.91 h-18.61c1.15-5.43,1.76-11.02,1.76-16.7c0-9.8-1.78-19.33-5.13-28.24c13.29-10.47,29.07-17.29,45.74-19.72 C424.603,143.362,433.923,143.372,443.133,144.712z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.2389,
    y1: 96.5417,
    x2: 384.2389,
    y2: 156.8517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DD401"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    style: {
      stopColor: "#9BD101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    style: {
      stopColor: "#94C701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#88B701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5753,
    style: {
      stopColor: "#77A001"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    style: {
      stopColor: "#618301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7933,
    style: {
      stopColor: "#465F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#263400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#020300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M419.943,96.542c0.09,14.06-2.59,27.69-7.96,40.61c-16.55,2.78-32.23,9.54-45.67,19.7 c-3.8-7.58-8.81-14.59-14.99-20.76c-0.91-0.91-1.84-1.8-2.79-2.66C366.493,112.112,392.203,98.842,419.943,96.542z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.0178,
    y1: 312.8617,
    x2: 241.0178,
    y2: 253.3617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2073,
    style: {
      stopColor: "#E9D5B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4752,
    style: {
      stopColor: "#DCC5AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7749,
    style: {
      stopColor: "#C8AB95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B59280"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M381.013,253.362v59.5h-279.99v-59.5H381.013z M343.283,299.772v-4.5c0-2.21-1.79-4-4-4 c-2.21,0-4,1.79-4,4v0.5h-12.91v-8h9.91c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4h-9.91v-8h12.91v0.5c0,2.21,1.79,4,4,4 c2.21,0,4-1.79,4-4v-4.5c0-2.21-1.79-4-4-4h-20.91c-2.21,0-4,1.79-4,4v32c0,2.21,1.79,4,4,4h20.91 C341.493,303.772,343.283,301.982,343.283,299.772z M294.083,267.772c0-2.21-1.79-4-4-4h-10.5c-2.21,0-4,1.79-4,4 c0,1.92,1.35,3.52,3.15,3.91l-9.57,19.15l-9.64-19.28c1.6-0.52,2.76-2.01,2.76-3.78c0-2.21-1.79-4-4-4h-10.5c-2.21,0-4,1.79-4,4 c0,2.21,1.79,4,4,4h2.91l14.89,29.79c0.68,1.36,2.06,2.21,3.58,2.21c1.51,0,2.9-0.85,3.58-2.21l14.89-29.79h2.45 C292.293,271.772,294.083,269.982,294.083,267.772z M226.513,283.772c0-11.03-8.97-20-20-20s-20,8.97-20,20c0,11.03,8.97,20,20,20 S226.513,294.802,226.513,283.772z M164.283,299.772v-6.5c0-2.21-1.79-4-4-4c-2.21,0-4,1.79-4,4v2.5h-12.91v-28c0-2.21-1.79-4-4-4 c-2.21,0-4,1.79-4,4v32c0,2.21,1.79,4,4,4h20.91C162.493,303.772,164.283,301.982,164.283,299.772z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.1078,
    y1: 245.3617,
    x2: 365.1078,
    y2: 233.6617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M375.293,245.362h-20.37c3.23-3.67,6.1-7.58,8.57-11.7L375.293,245.362z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.7628,
    y1: 210.8117,
    x2: 131.6528,
    y2: 210.8117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    style: {
      stopColor: "#E71B23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    style: {
      stopColor: "#D71921"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4757,
    style: {
      stopColor: "#BD161D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    style: {
      stopColor: "#971217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    style: {
      stopColor: "#680C10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4B090B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M364.873,176.262c1.23,5.32,1.89,10.81,1.89,16.4c0,19.23-7.49,37.31-21.09,50.91l-1.79,1.79 h-205.73l-1.78-1.79c-1.67-1.66-3.24-3.4-4.72-5.19l18.06-16.06c25.48-22.66,62.33-28.92,93.86-15.93 c31.19,12.84,66.24,8.87,93.76-10.63L364.873,176.262z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.2828,
    y1: 176.2817,
    x2: 362.4928,
    y2: 176.2817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    style: {
      stopColor: "#E71B23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    style: {
      stopColor: "#D71921"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4757,
    style: {
      stopColor: "#BD161D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    style: {
      stopColor: "#971217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    style: {
      stopColor: "#680C10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4B090B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M362.493,168.142l-29.78,21.1c-25.27,17.9-57.46,21.54-86.09,9.75 c-16.97-6.99-35.51-9.05-53.6-5.99c-18.1,3.08-34.91,11.15-48.63,23.34l-17.49,15.56c-7.56-11.58-11.62-25.09-11.62-39.24 c0-19.23,7.49-37.31,21.09-50.91c13.59-13.6,31.67-21.09,50.91-21.09c19.23,0,37.31,7.49,50.91,21.09l2.83,2.83l2.83-2.83 c13.59-13.6,31.67-21.09,50.91-21.09c19.23,0,37.31,7.49,50.91,21.09C353.263,149.342,358.943,158.332,362.493,168.142z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.283,295.272v4.5c0,2.21-1.79,4-4,4h-20.91c-2.21,0-4-1.79-4-4v-32c0-2.21,1.79-4,4-4h20.91c2.21,0,4,1.79,4,4v4.5 c0,2.21-1.79,4-4,4c-2.21,0-4-1.79-4-4v-0.5h-12.91v8h9.91c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4h-9.91v8h12.91v-0.5 c0-2.21,1.79-4,4-4C341.493,291.272,343.283,293.062,343.283,295.272z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.6378,
    y1: 384.2117,
    x2: 307.6378,
    y2: 320.8617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DD401"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    style: {
      stopColor: "#9BD101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    style: {
      stopColor: "#94C701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#88B701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5753,
    style: {
      stopColor: "#77A001"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    style: {
      stopColor: "#618301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7933,
    style: {
      stopColor: "#465F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#263400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#020300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M328.973,320.862c2.58,8.41,3.91,17.09,3.91,25.86c0,12.9-2.92,25.78-8.48,37.49 c-22.98-13.65-38.36-36.86-42.01-63.35H328.973z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.083,263.772c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4h-2.45l-14.89,29.79c-0.68,1.36-2.07,2.21-3.58,2.21 c-1.52,0-2.9-0.85-3.58-2.21l-14.89-29.79h-2.91c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4h10.5c2.21,0,4,1.79,4,4 c0,1.77-1.16,3.26-2.76,3.78l9.64,19.28l9.57-19.15c-1.8-0.39-3.15-1.99-3.15-3.91c0-2.21,1.79-4,4-4H290.083z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.6528,
    y1: 334.5417,
    x2: 268.3828,
    y2: 334.5417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    style: {
      stopColor: "#E71B23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    style: {
      stopColor: "#D71921"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4757,
    style: {
      stopColor: "#BD161D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6753,
    style: {
      stopColor: "#971217"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    style: {
      stopColor: "#680C10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4B090B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    points: "268.383,320.862 241.023,348.222 213.653,320.862  "
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.513,263.772c11.03,0,20,8.97,20,20c0,11.03-8.97,20-20,20s-20-8.97-20-20 C186.513,272.742,195.483,263.772,206.513,263.772z M218.513,283.772c0-6.62-5.38-12-12-12c-6.61,0-12,5.38-12,12 c0,6.62,5.39,12,12,12C213.133,295.772,218.513,290.392,218.513,283.772z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.5128,
    y1: 295.7717,
    x2: 206.5128,
    y2: 271.7717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3936,
    style: {
      stopColor: "#EBD8BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    style: {
      stopColor: "#E4D0B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8354,
    style: {
      stopColor: "#D9C2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CBAF98"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M206.513,271.772c6.62,0,12,5.38,12,12c0,6.62-5.38,12-12,12c-6.61,0-12-5.38-12-12 C194.513,277.152,199.903,271.772,206.513,271.772z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.4028,
    y1: 384.2117,
    x2: 174.4028,
    y2: 320.8617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DD401"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    style: {
      stopColor: "#9BD101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    style: {
      stopColor: "#94C701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#88B701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5753,
    style: {
      stopColor: "#77A001"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    style: {
      stopColor: "#618301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7933,
    style: {
      stopColor: "#465F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#263400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#020300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M153.073,320.862h46.57c-3.64,26.49-19.02,49.7-42.01,63.35 c-5.55-11.71-8.47-24.59-8.47-37.49C149.163,337.952,150.483,329.272,153.073,320.862z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.283,293.272v6.5c0,2.21-1.79,4-4,4h-20.91c-2.21,0-4-1.79-4-4v-32c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4v28h12.91v-2.5 c0-2.21,1.79-4,4-4C162.493,289.272,164.283,291.062,164.283,293.272z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.7969,
    y1: 96.5417,
    x2: 97.7969,
    y2: 156.8517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DD401"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    style: {
      stopColor: "#9BD101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    style: {
      stopColor: "#94C701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#88B701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5753,
    style: {
      stopColor: "#77A001"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    style: {
      stopColor: "#618301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7933,
    style: {
      stopColor: "#465F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#263400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#020300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M133.503,133.432c-0.95,0.86-1.88,1.75-2.79,2.66c-6.17,6.17-11.19,13.18-14.99,20.76 c-13.44-10.16-29.12-16.92-45.66-19.7c-5.38-12.92-8.05-26.55-7.97-40.61C89.843,98.842,115.543,112.112,133.503,133.432z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.9328,
    y1: 245.3617,
    x2: 116.9328,
    y2: 233.6617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M127.113,245.362h-20.36l11.8-11.7C121.023,237.782,123.893,241.692,127.113,245.362z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3128,
    y1: 247.1117,
    x2: 114.6528,
    y2: 247.1117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDBBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    style: {
      stopColor: "#E9D5B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    style: {
      stopColor: "#DCC5AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4338,
    style: {
      stopColor: "#C8AB95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5598,
    style: {
      stopColor: "#B59280"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#A28373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#715B50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9133,
    style: {
      stopColor: "#231C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9847,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M114.653,226.272l-20.43,20.24c-0.74,0.73-1.2,1.73-1.2,2.85v27.5h-78.71l29.35-26.79 c0.83-0.76,1.31-1.83,1.31-2.96c0-1.12-0.48-2.19-1.31-2.95l-29.35-26.8h96.86C112.153,220.402,113.303,223.372,114.653,226.272z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.6578,
    y1: 143.6979,
    x2: 75.6578,
    y2: 209.3617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DD401"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    style: {
      stopColor: "#9BD101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3313,
    style: {
      stopColor: "#94C701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#88B701"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5753,
    style: {
      stopColor: "#77A001"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6867,
    style: {
      stopColor: "#618301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7933,
    style: {
      stopColor: "#465F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#263400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#020300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M109.033,209.362h-18.61c-19.48-9.54-35.3-25.44-44.61-44.91c-3-6.27-5.32-12.89-6.91-19.74 c9.22-1.35,18.54-1.35,27.76-0.01c16.67,2.43,32.45,9.25,45.75,19.72c-3.36,8.91-5.13,18.44-5.13,28.24 C107.283,198.342,107.883,203.932,109.033,209.362z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.bbe0c6abfc80855e9b30137194b26766.svg";
export { ForwardRef as ReactComponent };